export const matomoEvent = (category: string = '', action: string = '', name: string = '', value: number = 0) => {
    if (localStorage.getItem('matomoDebug') === '1') {
        const entry = (category || '') + ' | ' + (action || '') + ' | ' + (name || '');
        console.log('%c[Matomo] ' + entry, 'background:#6c5ce7;color:#fff;padding:2px 6px;border-radius:3px');
        try {
            const log = JSON.parse(sessionStorage.getItem('_matomoLog') || '[]');
            log.push({ ts: new Date().toISOString(), category, action, name: name || '' });
            sessionStorage.setItem('_matomoLog', JSON.stringify(log));
        } catch (_) {}
    }
    if (window._paq) {
        window._paq.push(['trackEvent', category, action, name, value]);
    }
};
